/** @format */

import { HttpParams } from '@angular/common/http';

/**
 * @description
 * Utility class to handle query string parameter checks
 */
export class QueryStringParamService {
	/**
	 * @description
	 * Checks a given query string to determine if the parameter is present
	 */
	static doesQueryStringHaveParameter(queryString: string, parameter: string): boolean {
		// Default flag to false
		let returnFlag = false;

		// Ensure there is something to check
		if (
			typeof queryString === 'string' &&
			queryString.trim() !== '' &&
			typeof parameter === 'string' &&
			parameter.trim() !== ''
		) {
			// Create an HttpParams instance
			const httpParams = new HttpParams({ fromString: queryString });

			// Check using HttpParams
			returnFlag = httpParams.has(parameter);
		}

		// Return the flag
		return returnFlag;
	}
}
